module.exports = __webpack_public_path__ + "static/media/ssn.f53386be.svg";